import mapProps from '../scripts/utils/map-props';
import CascaderPanel from './cascader-panel';

export default mapProps(
  [
    'value',
  ],
  {
    model: {
      prop: 'value',
      event: 'change',
    },
  }
)(CascaderPanel);
